import styled from '@emotion/styled';

export const StyledMain = styled.main(({ theme }) => ({
    minHeight: '50vh',
    flexGrow: 1,
    paddingBottom: theme.space[5],
}));
